import { message } from "antd";


export const errorMessage = (title, duration = 3) => {
  const config = {
    content: title,
    duration: duration,
    onClick: () => { message.destroy(); },
  };
  message.error(config);
};
